import lottie from "lottie-web";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { applyBrandColors, LOADING_FILES_COLOR_MAP, computeResolvedVars } from '../../utils/lottieColorUtils';

const LoadingAnimation = React.forwardRef((props, ref) => {
    const containerLoading = useRef(null);
    const primaryColor = useSelector(state => state['Settings']?.['currentBranding']?.['primaryColor']);
    const isCustomBranding = useSelector(state => state['Settings']?.['isCustomBranding']);
    const brandingLoaded = useSelector(state => state['Settings']?.['brandingLoaded']);

    useEffect(() => {
        if (!brandingLoaded) return;
        let animation;
        let cancelled = false;
        const resolvedVars = isCustomBranding ? computeResolvedVars(primaryColor) : {};
        fetch('/animation/loading-files.json')
            .then(r => r.json())
            .then(data => {
                if (cancelled || !containerLoading.current) return;
                containerLoading.current.innerHTML = ''; // remove any stale SVG so only the fresh brand-colored one renders
                animation = lottie.loadAnimation({
                    container: containerLoading.current,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    animationData: applyBrandColors(data, LOADING_FILES_COLOR_MAP, resolvedVars),
                });
            });
        return () => { cancelled = true; animation?.destroy(); };
    }, [primaryColor, brandingLoaded]);

    return (
        <div className="svg-animation-loader" ref={containerLoading} style={{ width: "400px", height: "400px", background: "transparent" }} />
    );
});

export default LoadingAnimation;
